import React from "react";
import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";
import Select from "react-select";
import { getCurrentPartnerId } from "../../../utils/auth/partnerhelpers";

export default function TaskTypeSelector(props) {
  const { loading, data } = useQuery(QUERY, {
    fetchPolicy: "no-cache",
    variables: {
      partner_id: getCurrentPartnerId(),
    },
  });

  if (loading) return null;

  function handleChange(e) {
    props.onChange(e ? e.value : null);
  }

  const options = data.partner_task_type.map(function (e, index) {
    return {
      value: e.id,
      label: e.task_type_name,
      color: e.color,
      key: index,
    };
  });

  const selected = options.find((o) => o.value === props.value) || null;

  const colorDot = (color) => ({
    display: "inline-block",
    width: "12px",
    height: "12px",
    borderRadius: "3px",
    backgroundColor: color || "#ccc",
    marginRight: "8px",
    verticalAlign: "middle",
  });

  const formatOptionLabel = ({ label, color }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <span style={colorDot(color)} />
      <span>{label}</span>
    </div>
  );

  return (
    <Select
      id={props.name}
      options={options}
      onChange={handleChange}
      onBlur={props.onBlur}
      value={selected}
      isMulti={false}
      isClearable={true}
      isDisabled={props.disabled}
      placeholder={props.placeholder || "None"}
      formatOptionLabel={formatOptionLabel}
    />
  );
}

const QUERY = gql`
  query getTaskTypes($partner_id: Int!) {
    partner_task_type(
      order_by: { task_type_name: asc }
      where: { partner_id: { _eq: $partner_id } }
    ) {
      id
      task_type_name
      color
    }
  }
`;
